export interface AnimationStep {
  // startStep function should initiate animation step and call onComplete method upon step completion
  startStep: (onComplete: () => void) => void;
}

// Animation player plays animation steps
export class AnimationPlayer {
  private steps: AnimationStep[];

  private onComplete: () => void;

  private isStopped: boolean;

  constructor(steps: AnimationStep[], onComplete: () => void = () => {}) {
    this.steps = steps;
    this.onComplete = onComplete;
    this.isStopped = false;
    this.playStep(0);
  }

  public stop() {
    this.isStopped = true;
  }

  private playStep(stepIndex: number) {
    if (this.isStopped || stepIndex >= this.steps.length) {
      this.onComplete();
      return;
    }
    const onStepComplete = () => {
      this.playStep(stepIndex + 1);
    };
    this.steps[stepIndex].startStep(onStepComplete);
  }
}
